<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs6 md3 lg2 class="headline" v-if="isOrg">
        <v-select
          :items="warehouses"
          :label="$t('selectVendor')"
          item-text="warehouseName"
          return-object
          @change="changeWarehouse"
          v-model="currentWarehouse"></v-select>
      </v-flex>

      <v-flex xs3 lg1 v-if="isOrg">
        <v-btn color="primary" @click="addNewSupport()">
          <v-icon>add</v-icon> {{ $t('case') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-tabs
      color="transparent"
      v-model="tab"
      show-arrows
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab
        v-for="(tabItem) in tabs"
        :key="tabItem"
      >
        <span class="tabItem">
          {{ $t(tabItem.toLowerCase()) }}
        </span>
      </v-tab>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item key="active">
          <v-layout row wrap justify-end align-baseline>
            <v-flex class="success--text caption">
              <v-layout align-end>
                <v-flex md2>
                  <span class="realtime-border px-1">{{ $t('realTIME') }}</span>
                </v-flex>
                <v-flex md3 v-if="!isOrg">
                  <v-select
                    :items="activeTagsList"
                    item-text="displayName"
                    item-value="key"
                    :label="$t('tag')"
                    height="24px"
                    v-model="targetTag"
                    style="margin-top:0;padding-top:0;height:20px;"
                    clearable
                  ></v-select>
                </v-flex>
                <v-flex md3>
                  <v-btn style="transform: translateY(10px)" dark color="primary" @click.stop="exportActiveSupports">
                    {{ $t('export') }}
                  </v-btn>
                </v-flex>
                <v-flex md3>
                  <v-select
                    :items="categories"
                    item-text="displayName"
                    item-value="value"
                    :label="$t('category')"
                    height="24px"
                    v-model="category"
                    style="margin-top:0;padding-top:0;height:20px;padding-right: 10px;"
                    clearable
                  ></v-select>
                </v-flex>
                <v-flex md3>
                  <v-select
                    :items="statuses"
                    item-text="displayName"
                    item-value="value"
                    :label="$t('status')"
                    height="24px"
                    v-model="status"
                    style="margin-top:0;padding-top:0;height:20px;"
                    clearable
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs2 >
              <v-text-field
                name="rtSearch"
                append-icon="filter_list"
                :label="$t('search')"
                single-line
                hide-details
                v-model="supportSearch"
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-data-table
            v-if="tabs[tab] === 'Active'"
            :headers="headers"
            :items.sync="activeSupports"
            :search="supportSearch"
            class="elevation-2 myDense"
            :rows-per-page-items="rowPerPage"
          >
            <template v-slot:items="props">
              <td>{{ props.item.caseNumber }}</td>
              <td>
                <v-layout column>
                  <v-flex>
                    {{$t('submitter')}}:
                    <span v-if="activeWarehouse">
                      {{ getOrgId(props.item.tenantKey) + ` (${props.item.tenantName})` }}
                    </span>
                    <span v-if="isOrg">
                      {{ props.item.warehouseName }}
                    </span>
                    <span v-if="isAdmin">
                      {{ props.item.tenantName || props.item.warehouseName }}
                    </span>
                  </v-flex>
                  <v-flex v-if="activeWarehouse || isAdmin">
                    {{$t('agent')}}: {{ agentDisplay(props.item) || '---' }}
                  </v-flex>
                  <v-flex v-if="!isOrg">
                    {{$t('tag')}}:
                    <v-layout justify-start align-center>
                      <v-flex v-if="props.item.supportTags.length">
                        <v-chip v-for="tag in props.item.supportTags" :key="tag">{{ tag }}</v-chip>
                      </v-flex>
                      <v-flex md2>
                        <v-icon small @click="showEditTagsPopup(props.item)">edit</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </td>
              <td>{{ showStatus(props.item.status) }}</td>
              <td>{{$t(capitalize(props.item.category)) }}</td>
              <td>
                <v-layout row wrap :class="questionClass">
                  <v-flex my-2 xs12>
                    <b class="mr-2">{{ $t('title') }}:</b> {{ props.item.title }}
                  </v-flex>
                  <v-flex my-2 xs12 v-if="hasTracking(props.item)">
                    <b class="mr-2">{{ $t('Tracking#') }}:</b> {{ formatTracking(props.item) }}
                  </v-flex>
                  <v-flex
                    class="text-truncate"
                    v-if="(props.item.comments || []).length"
                    mb-2 xs12>
                    <b class="mr-2">
                      {{ props.item.comments[props.item.comments.length-1].name }}
                      [{{ toDateMMDDHHmm(props.item.comments[props.item.comments.length-1].createTime) }}]:
                    </b>
                    {{ lastCommentPreview(props.item) }}
                  </v-flex>
                </v-layout>
              </td>
              <td>{{ toTimestampString(props.item.createTime) }}</td>
              <td text-xs-center>
                <v-layout row class="bagdeRightTopClass btnWithoutPaddingMargin">
                  <v-flex>
                    <v-btn dark color="primary" flat @click.stop="showCommentsDialog(props.item)">
                      <v-badge :value="checkNewComment(props.item)" color="red" overlap>
                        <template v-slot:badge>
                          <span class="badge">{{ $t('new') }}</span>
                        </template>
                      </v-badge>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" v-on="on" small>comment</v-icon>
                        </template>
                        <span>{{$t('open')}}</span>
                      </v-tooltip>
                    </v-btn>
                  </v-flex>
                  <v-flex v-if="activeWarehouse || isAdmin">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" dark color="primary" flat @click.stop="showInternalCommentsDialog(props.item)" medium>
                          <v-badge :value="checkNewInternalComment(props.item)" color="red" overlap>
                            <template v-slot:badge>
                              <span class="badge">{{ $t('new') }}</span>
                            </template>
                          </v-badge>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon color="primary" v-on="on" small>checklist</v-icon>
                            </template>
                            <span>{{$t('internal')}}</span>
                          </v-tooltip>
                        </v-btn>
                      </template>
                      <div style="white-space: pre-wrap; word-break: break-word; max-width: 300px">{{
                        props.item.internalComments && props.item.internalComments.length ?
                          ( props.item.internalComments[props.item.internalComments.length - 1].name + ': ' +
                            props.item.internalComments[props.item.internalComments.length - 1].content +
                           ( props.item.internalComments[props.item.internalComments.length - 1].file ? ' [attachment]' : '')
                          ) :
                          `-- ${$t('noLastMessage')} --`
                      }}</div>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </td>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item key="history">
          <PaginationController
            v-if="tabs[tab] === 'History'"
            v-model="doneSupports"
            :refresh="paginationRefreshTrigger"
            getDataActionName="getDoneSupports"
            :historyLimit="historyLimit"
            :haveSearchBox="!!activeWarehouse || isAdmin"
            :searchBoxLabel="$t('orgName/orgId/title/tags')"
            :select="currentWarehouse.warehouseKey"
            :actionPredicates="actionPredicates"
            keepKeywordCase
          >
            <template  v-slot:beforeMenu>
              <v-layout>
                <v-flex xs12 ml-2 text-xs-left>
                  {{ $t('closedCasesWillBeRemovedAfterOneYear') }}
                </v-flex>
              </v-layout>
            </template>
            <template  v-slot:beforeDate>
              <v-layout>
                <v-flex md24>
                  <v-select
                    :items="categories"
                    item-text="displayName"
                    item-value="value"
                    :label="$t('category')"
                    height="24px"
                    v-model="historyCategory"
                    style="margin-top:0;padding-top:0;height:20px;padding-right: 10px;"
                    clearable
                  ></v-select>
                </v-flex>
              </v-layout>
            </template>
            <template v-slot:afterDate>
              <v-flex xs2>
                <v-text-field
                  class="rtSearch"
                  name="rtSearch"
                  append-icon="filter_list"
                  :label="$t('search')"
                  single-line
                  hide-details
                  v-model="supportSearchHistory"
                  clearable
                ></v-text-field>
              </v-flex>
            </template>
            <template v-slot:dataTable>
              <v-data-table
                :headers="closedHeaders"
                :items="historySupports"
                hide-actions
                :search="supportSearchHistory"
              >
                <template v-slot:items="props">
                  <td>{{ props.item.caseNumber }}</td>
                  <td>
                    <v-layout column>
                      <v-flex>
                        {{$t('submitter')}}:
                        <span v-if="activeWarehouse">
                          {{ getOrgId(props.item.tenantKey) + ` (${props.item.tenantName})` }}
                        </span>
                        <span v-if="isOrg">
                          {{ props.item.warehouseName }}
                        </span>
                        <span v-if="isAdmin">
                          {{ props.item.tenantName || props.item.warehouseName }}
                        </span>
                      </v-flex>
                      <v-flex v-if="activeWarehouse || isAdmin">
                        {{$t('agent')}}: {{ agentDisplay(props.item) || '---' }}
                      </v-flex>
                      <v-flex v-if="!isOrg">
                        {{$t('tag')}}:
                        <v-layout justify-start align-center>
                          <v-flex v-if="(props.item.supportTags || []).length">
                            <v-chip v-for="tag in props.item.supportTags" :key="tag">{{ tag}}</v-chip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </td>
                  <td>{{$t(capitalize(props.item.category)) }}</td>
                  <td :class="questionClass">
                    <v-layout row wrap>
                      <v-flex my-2 xs12>
                        <b class="mr-2">{{ $t('title') }}:</b>{{ props.item.title }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex my-2 xs12 v-if="hasTracking(props.item)">
                        <b class="mr-2">{{ $t('tracking#') }}:</b> {{ formatTracking(props.item) }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap  v-if="(activeWarehouse || isAdmin) && props.item.keywordDisplay">
                      <v-flex my-2>
                        <b class="mr-2">{{ $t('keywords') }}:</b>{{ props.item.keywordDisplay }}
                      </v-flex>
                    </v-layout>

                  </td>
                  <td v-if="activeWarehouse || isAdmin">
                    <v-layout row wrap>
                      {{ props.item.resolveTypes && props.item.resolveTypes.join(', ') }}
                    </v-layout>
                    <v-layout row wrap v-if="!!props.item.amount">
                      {{ `$${props.item.amount}` }}
                    </v-layout>
                  </td>
                  <td>{{ toTimestampString(props.item.lastModifiedTime) }}</td>
                  <td text-xs-center>
                    <v-layout row class="bagdeRightTopClass btnWithoutPaddingMargin">
                      <v-flex>
                        <v-btn dark color="primary" flat @click.stop="showCommentsDialog(props.item)">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon color="primary" v-on="on" small>comment</v-icon>
                            </template>
                            <span>{{$t('open')}}</span>
                          </v-tooltip>
                        </v-btn>
                      </v-flex>
                      <v-flex v-if="activeWarehouse|| isAdmin">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" dark color="primary" flat @click.stop="showInternalCommentsDialog(props.item)">
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-icon color="primary" v-on="on" small>checklist</v-icon>
                                </template>
                                <span>{{$t('internal')}}</span>
                              </v-tooltip>
                            </v-btn>
                          </template>
                          <div style="white-space: pre-wrap; word-break: break-word; max-width: 300px">{{
                            props.item.internalComments && props.item.internalComments.length ?
                              ( props.item.internalComments[props.item.internalComments.length - 1].name + ': ' +
                                props.item.internalComments[props.item.internalComments.length - 1].content +
                              ( props.item.internalComments[props.item.internalComments.length - 1].file ? ' [attachment]' : '')
                              ) :
                              `-- ${$t('noLastMessage')} --`
                          }}</div>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </template>
          </PaginationController>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <SupportEdit
      v-if="supportEditorToggle"
      v-model="supportEditorToggle"
      :initWarehouse="currentWarehouse"
      :support="supportInEdit"
    />
    <ChatRoom
      v-model="commentsDialog"
      :title="$t('supportChatRoomTitle', { caseNumber: supportInEdit.caseNumber, status: showStatus(supportInEdit.status) })"
      v-if="commentsDialog"
      :maxTextQty="1000"
      :lastReadTime="supportLastRead"
      :docPath="['supports', supportKey]"
      :comments="supportComments"
      :readOnly="supportInEdit && supportInEdit.status === 'closed'"
      :nickName="(activeWarehouse || isAdmin) ? supportAgent : ''"
      enableFileUpload
      :customSizeLimit="10485760 * 2"
    >
      <template v-slot:issue>
        <v-card hover raised>
          <v-card-text>
            <div class="cardTitle" style="overflow-wrap: break-word;">{{ $t('createTime') }}: {{ toTimestampString(supportInEdit.createTime) }}</div>
            <div v-if="activeWarehouse" class="cardTitle" style="overflow-wrap: break-word;">{{ $t('organization') }}: {{ getOrgId(supportInEdit.tenantKey) + ` (${supportInEdit.tenantName})` }}</div>
            <div v-else class="cardTitle" style="overflow-wrap: break-word;">{{ $t('warehouse') }}: {{ supportInEdit.warehouseName }}</div>
            <div class="cardTitle" >{{toTimestampString(supportInEdit.createTime)}}</div>
            <br />
            <template v-if="supportInEdit.address">
              <div class="cardTitle" style="overflow-wrap: break-word;">{{ $t('address') }}</div>
              <div class="cardText">
                <span class="font-weight-bold">{{ $t('sender') }}</span>: {{getLabelAddressInfo(supportInEdit.address, 'sender')}}</div>
              <div class="cardText">
                <span class="font-weight-bold">{{ $t('recipient') }}</span>: {{getLabelAddressInfo(supportInEdit.address, 'recipient')}}</div>
              <br />
            </template>
            <div class="cardTitle" style="overflow-wrap: break-word;">{{ $t('question') }}: {{supportInEdit.title}}</div>
            <div class="cardText" v-if="hasTracking(supportInEdit)">
              <span class="font-weight-bold">{{ $t('tracking') }}</span>: {{formatTracking(supportInEdit)}}</div>
            <div class="cardText" v-if="supportInEdit.upc">
              <span class="font-weight-bold">Upc</span>: {{supportInEdit.upc}}</div>
            <div class="cardText" v-if="supportInEdit.labelId">
              <span class="font-weight-bold">{{ $t('LabelID') }}</span>: {{supportInEdit.labelId}}</div>
            <div class="cardText" v-if="supportInEdit.quantity !== undefined && supportInEdit.quantity !== ''">
              <span class="font-weight-bold">{{ $t('qty') }}</span>: {{supportInEdit.quantity}}</div>
            <div class="cardText" v-if="supportInEdit.shipmentId">
              <span class="font-weight-bold">{{ $t('shipmentID') }}</span>: {{supportInEdit.shipmentId}}</div>
            <div class="cardText" v-if="supportInEdit.pickUpDate">
              <span class="font-weight-bold">{{ $t('pickUpDate') }}</span>: {{ supportInEdit.pickUpDate }}</div>
            <div class="cardText" v-if="supportInEdit.productDescription">
              <span class="font-weight-bold">{{ $t('productDescription') }}</span>: {{ supportInEdit.productDescription }}</div>
            <div class="cardText" v-if="supportInEdit.totalWeight">
              <span class="font-weight-bold">{{ $t('totalWeightUpperCase') }}</span>: {{ supportInEdit.totalWeight }}</div>
            <div class="cardText" v-if="supportInEdit.productValue">
              <span class="font-weight-bold">{{ $t('productValue') }}</span>: {{ supportInEdit.productValue }}</div>
            <div class="cardText" v-if="supportInEdit.totalValue">
              <span class="font-weight-bold">{{ $t('totalValue') }}</span>: {{ supportInEdit.totalValue }}</div>
            <div class="cardText" v-if="supportInEdit.postageAmount">
              <span class="font-weight-bold">{{ $t('postageAmount') }}</span>: {{ supportInEdit.postageAmount }}</div>
            <div class="cardText" v-if="supportInEdit.length || supportInEdit.width || supportInEdit.height">
              <span class="font-weight-bold">{{ $t('packageSize') }}</span>: {{ supportInEdit.length || 0 }} x {{ supportInEdit.width || 0 }} x {{ supportInEdit.height || 0 }}</div>
            <div class="cardText">{{supportInEdit.question}}</div>
            <v-layout v-if="(supportInEdit.attachments || []).length" row wrap>
              <FsFileChip
                v-for="(file, index) in supportInEdit.attachments"
                :file="file"
                :key="'file' + index"
                width="100%"
                aspect-ratio="1.7"
                class="ma-2"
              />
            </v-layout>
          </v-card-text>
        </v-card>
      </template>
      <template v-if="(activeWarehouse || isAdmin) && tab === 0 && supportInEdit && supportInEdit.status !== 'closed'" v-slot:operation>
        <v-layout row no-wrap align-baseline>
          <v-flex xs4>
            <v-select
              :label="$t('status')"
              class="chatroom-op mx-2"
              :items="supportStatus"
              item-text="displayName"
              item-value="value"
              v-model="supportInEditNewStatus"
            ></v-select>
          </v-flex>

          <v-flex v-if="supportInEditNewStatus === 'in progress' || supportInEditNewStatus === 'closed'" xs4>
            <v-text-field
              name="agentName"
              class="chatroom-op mx-2"
              :label="$t('agentName')"
              :value="supportAgent"
              :readonly="supportInEditNewStatus === 'closed'"
              v-model="agentName"
              :clearable="supportInEditNewStatus !== 'closed'"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-btn small color="primary" @click.stop="updateSupportStatus()">{{ $t('change') }}</v-btn>
          </v-flex>
          <v-flex>
            <v-btn v-if="supportInEdit.status !== 'closed'" small color="primary" @click.stop="showResolvePopup">{{ $t('resolve') }}</v-btn>
          </v-flex>
        </v-layout>
      </template>
    </ChatRoom>

    <ChatRoom
      v-model="internalCommentsDialog"
      :title="$t('supportChatRoomInternalTitle', { caseNumber: supportInEdit.caseNumber, status: showStatus(supportInEdit.status)})"
      v-if="internalCommentsDialog"
      :lastReadTime="internalCommentsLastRead"
      :docPath="['supports', supportKey]"
      commentsField="internalComments"
      :comments="internalComments"
      :readOnly="supportInEdit && supportInEdit.status === 'closed'"
      enableFileUpload
      :customSizeLimit="10485760 * 2"
    />
    <SupportResolvePopup
      v-if="resolveDialogFlag"
      v-model="resolveDialogFlag"
      :supportKey="supportKey"
      :defaultAmount="estimatedResolveAmount"
      @resolved="onSupportResolved"
    />
    <SimpleTextPopup
      v-model="isShowEditTagsPopup"
      v-if="isShowEditTagsPopup"
      @popupClose="() => this.isShowEditTagsPopup = false"
      :rightMethod="saveTags"
      >
      <template v-slot:input>
        <v-combobox
          :items="activeTagsList"
          v-model="currentItemTagKeys"
          item-text="displayName"
          item-value="key"
          :label="$t('serviceType')"
          :return-object="false"
          chips
          multiple
          clearable />
      </template>
    </SimpleTextPopup>
  </v-container>
</template>

<script>
import { timeTools, capitalize, exportListToXlsx } from '@/utils/tools'
import SupportEdit from '@/components/SupportEdit'
import ChatRoom from '@/components/ChatRoom'
import SupportResolvePopup from '@/components/SupportResolvePopup'
import FsFileChip from '@/components/FsFileChip'
import PaginationController from './PaginationController'
import SimpleTextPopup from './SimpleTextPopup.vue'

const SYSTEM_CASE_ESTIMATE_PRICE_MAP = {
  INTERCEPT_REASSIGN: 5,
  RETURN_RESEND: 11,
  RETURN_DESTROY: 11,
  DOWNLOAD_POD: 3
}

export default {
  name: 'Support',
  components: {
    SupportEdit,
    ChatRoom,
    PaginationController,
    FsFileChip,
    SupportResolvePopup,
    SimpleTextPopup
  },
  mixins: [timeTools],
  props: {
    caseKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tab: 0,
      tabs: ['Active', 'History'],
      supportEditorToggle: false,
      supportInEdit: {},
      supportInEditNewStatus: '',
      commentsDialog: false,
      internalCommentsDialog: false,
      currentWarehouse: {},
      rowPerPage: [30, 50, {text: this.$t('all'), value: -1}],
      paginationRefreshTrigger: false,
      doneSupports: [],
      supportSearch: '',
      supportSearchHistory: '',
      agentName: '',
      historyLimit: 25,
      resolveDialogFlag: false,
      defaultTagTypes: [], // 可用于添加默认基础tag类型,
      targetTag: '',
      isShowEditTagsPopup: false,
      currentItemTagKeys: [],
      category: '',
      status: '',
      historyCategory: '',
      handledCaseKey: ''
    }
  },
  beforeMount () {
    if (this.warehouses && this.warehouses.length) this.currentWarehouse = this.warehouses[0]
  },
  mounted () {
    this.openRequestedSupportCase()
  },
  watch: {
    caseKey () {
      this.handledCaseKey = ''
      this.openRequestedSupportCase()
    },
    warehouses (curWarehouses, oldWarehouses) {
      if (!this.currentWarehouse.warehouseKey) {
        if (this.warehouses && this.warehouses.length) this.currentWarehouse = this.warehouses[0]
      } else {
        this.currentWarehouse = this.warehouses.find(warehouse => warehouse.warehouseKey === this.currentWarehouse.warehouseKey) || this.currentWarehouse
      }
    },
    activeSupports () {
      if (this.supportInEdit && this.supportInEdit._key) {
        const rawSupports = [
          ...(this.$store.getters.supports || []),
          ...(this.$store.getters.viteSupports || [])
        ]
        const newInEdit = rawSupports.find(({_key}) => _key === this.supportInEdit._key)
        if (newInEdit) {
          this.supportInEdit = newInEdit
        }
      }
    },
    tab (cur) {
      if (cur === 1) {
        this.paginationRefreshTrigger = !this.paginationRefreshTrigger
      }
    },
    supportInEditNewStatus (cur) {
      if (cur === 'in progress') {
        this.agentName = this.supportAgent
      } else if (cur === 'closed') {
        this.agentName = this.supportInEdit.agentName
      }
    }
  },
  computed: {
    actionPredicates () {
      let predicates = []
      if (this.historyCategory) {
        predicates.push({
          field: 'category',
          compare: '==',
          value: this.historyCategory
        })
      }
      return predicates
    },
    statuses () {
      return [
        {
          displayName: this.$t('pending'),
          value: 'pending'
        },
        {
          displayName: this.$t('inProgress'),
          value: 'in progress'
        }
        // {
        //   displayName: this.$t('closed'),
        //   value: 'closed'
        // }
      ]
    },
    categories () {
      return this.currentWarehouse.warehouseKey === 'system' ? [
        {
          displayName: this.$t('INTERCEPT_REASSIGN'),
          value: 'INTERCEPT_REASSIGN'
        }, {
          displayName: this.$t('RETURN_RESEND'),
          value: 'RETURN_RESEND'
        }, {
          displayName: this.$t('RETURN_DESTROY'),
          value: 'RETURN_DESTROY'
        }, {
          displayName: this.$t('DOWNLOAD_POD'),
          value: 'DOWNLOAD_POD'
        }, {
          displayName: this.$t('LOST_DAMAGED_SIZE_CLAIM'),
          value: 'LOST_DAMAGED_SIZE_CLAIM'
        }, {
          displayName: this.$t('OTHER'),
          value: 'OTHER'
        }
      ] : [
        {
          displayName: this.$t('billing'),
          value: 'billing'
        }, {
          displayName: this.$t('inbound'),
          value: 'Inbound'
        }, {
          displayName: this.$t('outbound'),
          value: 'outbound'
        }, {
          displayName: this.$t('others'),
          value: 'others'
        }
      ]
    },
    headers () {
      if (this.isOrg) {
        return [
          { text: this.$t('caseNumber'), align: 'left', sortable: (this.tabs[this.tab] === 'Active'), value: 'caseNumber', width: '8%' },
          { text: this.$t('vendor'), align: 'left', sortable: (this.tabs[this.tab] === 'Active'), value: 'warehouseName' },
          { text: this.$t('status'), value: 'status', align: 'left', sortable: false },
          { text: this.$t('category'), value: 'category', align: 'left', sortable: false },
          { text: this.$t('details'), value: 'keywordString', align: 'left', sortable: false, width: '40%' },
          { text: this.$t(this.tabs[this.tab] === 'Active' ? 'createTime' : 'closedTime'), value: 'createTime', align: 'left', sortable: false },
          { text: this.$t('actions'), value: 'keywordStr', align: 'center', sortable: false, width: '6%' }
        ]
      } else {
        if (this.tab === 0) {
          return [
            { text: this.$t('caseNumber'), align: 'left', sortable: (this.tabs[this.tab] === 'Active'), value: 'caseNumber', width: '8%' },
            { text: this.$t('caseInfo'), align: 'left', sortable: (this.tabs[this.tab] === 'Active'), value: '', width: '10%' },
            { text: this.$t('status'), value: 'status', align: 'left', sortable: false },
            { text: this.$t('category'), value: 'category', align: 'left', sortable: false },
            { text: this.$t('details'), value: 'keywordString', align: 'left', sortable: false, width: '40%' },
            { text: this.$t(this.tabs[this.tab] === 'Active' ? 'createTime' : 'closedTime'), value: 'createTime', align: 'left', sortable: false },
            { text: this.$t('actions'), value: 'keywordStr', align: 'center', sortable: false, width: '6%' }
          ]
        } else {
          return [
            { text: this.$t('caseNumber'), align: 'left', sortable: (this.tabs[this.tab] === 'Active'), value: 'caseNumber', width: '8%' },
            { text: this.$t('caseInfo'), align: 'left', sortable: (this.tabs[this.tab] === 'Active'), value: 'tenantName', width: '10%' },
            { text: this.$t('status'), value: 'status', align: 'left', sortable: false },
            { text: this.$t('category'), value: 'category', align: 'left', sortable: false },
            { text: this.$t('details'), value: 'keywordString', align: 'left', sortable: false, width: '40%' },
            { text: this.$t('resolution'), value: 'resolveType', align: 'left', sortable: false },
            { text: this.$t(this.tabs[this.tab] === 'Active' ? 'createTime' : 'closedTime'), value: 'createTime', align: 'left', sortable: false },
            { text: this.$t('actions'), value: 'keywordStr', align: 'center', sortable: false, width: '6%' }
          ]
        }
      }
    },
    closedHeaders () {
      return this.headers.filter(({text}) => text !== this.$t('status'))
    },
    warehouses () {
      return [
        ...this.$store.getters.allPreferredWarehouses,
        {
          warehouseName: 'System',
          warehouseKey: 'system',
          orgId: 'self'
        }
      ]
    },
    allActiveSupports () {
      return ([...this.$store.getters.supports, ...this.$store.getters.viteSupports] || [])
        .filter(support => {
          const isSupportOrg = this.isOrg ? support.warehouseKey === this.currentWarehouse.warehouseKey : true
          const isSupportCategory = this.category ? support.category === this.category : true
          const isSupportStatus = this.status ? support.status === this.status : true
          return isSupportOrg && isSupportCategory && isSupportStatus
        })
        .map(item => {
          const tracking = item.tracking || ''
          const trackings = Array.isArray(item.trackings)
            ? item.trackings.map(t => typeof t === 'object' && t !== null ? (t.trackingNumber || t.tracking) : t).filter(Boolean).join(' ')
            : ''
          const keywordString = `${item.title || ''} ${tracking} ${trackings} ${this.formatTracking(item)} ${item.keywords && item.keywords.join(' ')}`
          return {
            ...item,
            keywordString: keywordString
          }
        })
    },
    activeSupports () {
      return this.targetTag ? this.allActiveSupports.filter(support => support.supportTags.includes(this.targetTag)) : this.allActiveSupports
    },
    activeWarehouse () {
      return this.$store.getters.activeWarehouse
    },
    isOrg () {
      return this.$store.getters.activeOrganization
    },
    supportLastRead () {
      return (this.supportInEdit
        && this.supportInEdit[`lastRead_${this.$store.getters.uid}`]) || new Date('2018-1-1')
    },
    internalCommentsLastRead () {
      return (this.supportInEdit
        && this.supportInEdit[`lastRead_internalComments_${this.$store.getters.uid}`]) || new Date('2018-1-1')
    },
    supportKey () {
      return (this.supportInEdit && this.supportInEdit._key)
    },
    supportComments () {
      return (this.supportInEdit && this.supportInEdit.comments) || []
    },
    internalComments () {
      return (this.supportInEdit && this.supportInEdit.internalComments) || []
    },
    supportAgent () {
      return (this.supportInEdit && this.supportInEdit.agentName) ||
        (this.$store.getters.userExtra && this.$store.getters.userExtra.name) ||
        'IT support'
    },
    user () {
      return this.$store.getters.user
    },
    questionClass () {
      return this.$vuetify.breakpoint.mdAndDown ?
        'question-medium' :
        (
          this.$vuetify.breakpoint.lgOnly ?
            'question-large' :
            'question-xlarge'
        )
    },
    supportStatus () {
      return this.tab === 0 ? [
        {
          displayName: this.$t('pending'),
          value: 'pending'
        },
        {
          displayName: this.$t('inProgress'),
          value: 'in progress'
        }
      ] : [
        {
          displayName: this.$t('pending'),
          value: 'pending'
        },
        {
          displayName: this.$t('inProgress'),
          value: 'in progress'
        },
        {
          displayName: this.$t('closed'),
          value: 'closed'
        }
      ]
    },
    isAdmin () {
      return !!(this.$store.getters.user || {}).isAdmin
    },
    activeTagsList () {
      return Object.entries(this.allActiveSupports.reduce((prev, cur) => {
        const {supportTags = []} = cur
        supportTags.forEach(tag => {
          prev[tag] && (prev[tag] += 1)
          !prev[tag] && (prev[tag] = 1)
        })
        return prev
      }, {}) || {}).sort((a, b) => b['1'] - a['1']).map(item => item[0])
    },
    categoryActions () {
      return [
        { name: this.$t('INTERCEPT_REASSIGN'), value: 'INTERCEPT_REASSIGN' },
        { name: this.$t('RETURN_RESEND'), value: 'RETURN_RESEND' },
        { name: this.$t('RETURN_DESTROY'), value: 'RETURN_DESTROY' },
        { name: this.$t('DOWNLOAD_POD'), value: 'DOWNLOAD_POD' },
        // { name: this.$t('SIZE_CLAIM'), value: 'SIZE_CLAIM' },
        // { name: this.$t('LOST_DAMAGED_CLAIM'), value: 'LOST_DAMAGED_CLAIM' },
        { name: this.$t('LOST_DAMAGED_SIZE_CLAIM'), value: 'LOST_DAMAGED_SIZE_CLAIM' },
        { name: this.$t('OTHER'), value: 'OTHER' }
      ]
    },
    estimatedResolveAmount () {
      const support = this.supportInEdit || {}
      if (support.warehouseKey !== 'system') {
        return 0
      }

      const unitPrice = SYSTEM_CASE_ESTIMATE_PRICE_MAP[support.category]
      if (!unitPrice) {
        return 0
      }

      if (support.category === 'RETURN_RESEND') {
        const trackingCount = Array.isArray(support.resendPairs) && support.resendPairs.length > 0
          ? support.resendPairs.filter((pair) => {
            const oldTracking = String((pair && pair.oldTracking) || '').trim()
            const newTracking = String((pair && pair.newTracking) || '').trim()
            return oldTracking && newTracking
          }).length
          : (Array.isArray(support.trackings) && support.trackings.length > 0 ? 1 : (support.tracking ? 1 : 0))
        return parseInt(unitPrice * trackingCount, 10)
      }

      if (['INTERCEPT_REASSIGN', 'RETURN_DESTROY', 'DOWNLOAD_POD'].includes(support.category)) {
        const trackingCount = Array.isArray(support.trackings) && support.trackings.length > 0
          ? support.trackings.length
          : (support.tracking ? 1 : 0)
        return parseInt(unitPrice * trackingCount, 10)
      }

      return parseInt(unitPrice, 10)
    },
    // Helper to format tracking/trackings for display
    formatTracking () {
      return (item) => {
        if (item.category === 'RETURN_RESEND' && Array.isArray(item.resendPairs) && item.resendPairs.length > 0) {
          return item.resendPairs.map((pair) => {
            const oldTracking = String((pair && pair.oldTracking) || '').trim()
            const newTracking = String((pair && pair.newTracking) || '').trim()
            if (oldTracking && newTracking) {
              return `${oldTracking} -> ${newTracking}`
            }
            return oldTracking || newTracking
          }).filter(t => t).join(', ')
        }
        if (item.trackings && item.trackings.length) {
          return item.trackings.map(t => {
            // Handle object format: {trackingNumber: 'xxx', ...}
            if (typeof t === 'object' && t !== null) {
              return t.trackingNumber || t.tracking || JSON.stringify(t)
            }
            // Handle string format
            return t
          }).filter(t => t).join(', ')
        }
        if (item.tracking) {
          return item.tracking
        }
        return ''
      }
    },
    hasTracking () {
      return (item) => {
        const hasResendPairs = item.category === 'RETURN_RESEND' && Array.isArray(item.resendPairs) && item.resendPairs.some(pair => {
          const oldTracking = String((pair && pair.oldTracking) || '').trim()
          const newTracking = String((pair && pair.newTracking) || '').trim()
          return oldTracking || newTracking
        })
        return hasResendPairs || (item.trackings && item.trackings.length > 0) || item.tracking
      }
    },
    historySupports () {
      return (this.doneSupports || []).map(item => {
        const tracking = item.tracking || ''
        const trackings = Array.isArray(item.trackings)
          ? item.trackings.map(t => typeof t === 'object' && t !== null ? (t.trackingNumber || t.tracking) : t).filter(Boolean).join(' ')
          : ''
        return {
          ...item,
          keywordStr: `${item.title || ''} ${tracking} ${trackings} ${this.formatTracking(item)}`
        }
      })
    }
  },
  methods: {
    async openRequestedSupportCase () {
      const caseKey = String(this.caseKey || '').trim()
      if (!caseKey || caseKey === this.handledCaseKey) {
        return
      }

      const activeSupport = [
        ...(this.$store.getters.supports || []),
        ...(this.$store.getters.viteSupports || [])
      ].find(support => support._key === caseKey)

      try {
        const support = activeSupport || await this.$store.dispatch('getSupportByKey', caseKey)
        if (!support) {
          return
        }

        this.handledCaseKey = caseKey
        if (support.status === 'closed') {
          this.tab = 1
        }
        const warehouse = this.warehouses.find(item => item.warehouseKey === support.warehouseKey)
        if (warehouse) {
          this.currentWarehouse = warehouse
        }
        this.showCommentsDialog(support)
      } catch (error) {
        this.$store.dispatch('showToast', {
          info: error.message || this.$t('failed'),
          level: 'error'
        })
      }
    },
    changeWarehouse (warehouse) {
      this.category = ''
      this.historyCategory = ''
    },
    getLabelAddressInfo (address, type) {
      if (!address) return '--'
      if (type === 'sender') {
        return [
          address.fromFullName,
          address.fromPhoneNumber,
          address.fromState,
          address.fromCity,
          address.fromPostalCode,
          address.fromAddressLine1,
          address.fromAddressLine2
        ].filter(Boolean).join(', ')
      }
      if (type === 'recipient') {
        return [
          address.toFullName,
          address.toPhoneNumber,
          address.toState,
          address.toCity,
          address.toPostalCode,
          address.toAddressLine1,
          address.toAddressLine2
        ].filter(Boolean).join(', ')
      }
    },
    exportActiveSupports () {
      const targetHeaders = this.headers.slice(0, this.headers.length - 1)
      const headers = targetHeaders.map(item => item.text)
      const keys = targetHeaders.map(item => item.value)
      exportListToXlsx(
        [
          headers,
          ...this.activeSupports.map(item => keys.map((key, index) => {
            switch (index) {
              case 1: {
                let result = `${this.$t('submitter')}: `
                if (this.activeWarehouse) result += this.getOrgId(item.tenantKey) + ` (${item.tenantName})`
                if (this.isOrg) result += item.warehouseName
                if (this.isAdmin) result += item.tenantName || item.warehouseName
                if (this.activeWarehouse || this.isAdmin) {
                  result += `\n${this.$t('agent')}: ${this.agentDisplay(item) || '---'}`
                }
                if (!this.isOrg) result += `\n${this.$t('tag')}: ${item.supportTags.join(',')}`
                return result
              }
              case 2: {
                return this.showStatus(item.status)
              }
              case 3: {
                return this.capitalize(item.category)
              }
              case 4: {
                let result = `${this.$t('title')}: ${item.title}`
                if (this.hasTracking(item)) {
                  result += `\n ${this.$t('Tracking#')}: ${this.formatTracking(item)}`
                }
                if (item.comments?.length) {
                  result += `\n${item.comments[item.comments.length - 1].name}[${this.toDateMMDDHHmm(item.comments[item.comments.length - 1].createTime)}]: ${this.lastCommentPreview(item)}`
                }
                return result
              }
              case 5: {
                return this.toTimestampString(item.createTime)
              }
            }
            return item[key]
          }))
        ], `Active-Supports.csv`
      )
    },
    capitalize: capitalize,
    dispatchAndToast (promise, actionText) {
      return promise
        .catch(error => {
          this.$store.dispatch('showToast', {info: `${actionText} ${this.$t('failed')}` + error.message})
        })
    },
    showStatus (status) {
      return (this.supportStatus.find(({value}) => value === status) || {}).displayName || status
    },
    addNewSupport () {
      this.supportEditorToggle = true
      this.supportInEdit = {}
    },
    checkNewComment (request) {
      let lastReadTime = request[`lastRead_${this.$store.getters.uid}`]
      let hasOnlyInitialComment = request.comments && request.comments.length === 1 && request.comments[0].initialComment
      let lastMessageTime = request.comments && request.comments.length > 0 && request.comments.slice(-1)[0].createTime

      return !hasOnlyInitialComment && !!lastMessageTime && (!lastReadTime || lastReadTime < lastMessageTime)
    },
    checkNewInternalComment (request) {
      let lastReadTime = request[`lastRead_internalComments_${this.$store.getters.uid}`]
      let hasOnlyInitialComment = request.internalComments && request.internalComments.length === 1 && request.internalComments[0].initialComment
      let lastMessageTime = request.internalComments && request.internalComments.length > 0 && request.internalComments.slice(-1)[0].createTime

      return !hasOnlyInitialComment && !!lastMessageTime && (!lastReadTime || lastReadTime < lastMessageTime)
    },
    showCommentsDialog (item) {
      this.supportInEdit = item
      if (this.supportInEdit.agentUid) {
        this.agentName = this.supportInEdit.agentName
      } else {
        this.agentName = ''
      }
      this.supportInEditNewStatus = this.supportInEdit.status
      this.commentsDialog = true
    },
    showInternalCommentsDialog (item) {
      this.supportInEdit = item
      if (this.supportInEdit.agentUid) {
        this.agentName = this.supportInEdit.agentName
      } else {
        this.agentName = ''
      }
      this.supportInEditNewStatus = this.supportInEdit.status
      this.internalCommentsDialog = true
    },
    cancelSupport (item) {
      if (confirm(this.$t('confirmCancelSupport'))) {
        this.dispatchAndToast(this.$store.dispatch('cancelSupport', item))
      }
    },
    updateSupportStatus (payload = {
      status: this.supportInEditNewStatus,
      key: this.supportInEdit._key,
      agentUid: '',
      agentName: ''
    }, isResolveSupport = false) {
      if (['in progress', 'closed'].includes(payload.status)) {
        payload.agentUid = this.user.uid
        payload.agentName = this.agentName
        payload.keywords = isResolveSupport ?
          [...this.supportInEdit.keywords, ...this.supportInEdit.supportTags, this.user.uid]
          : [...this.supportInEdit.keywords, this.user.uid]
        payload.status === 'closed' && (payload.closedTime = new Date())
      }
      return this.dispatchAndToast(this.$store.dispatch('updateSupport', payload))
        .then(() => {
          if (payload.status === 'closed') {
            this.commentsDialog = false
          }
        })
    },
    lastCommentPreview (item) {
      let lastComment = item.comments[item.comments.length - 1].content || ''
      return lastComment.split('\n')[0] + (lastComment.split('\n')[0] ? '…' : '')
    },
    agentDisplay (item) {
      if (item.agentName) return item.agentName
      else if (!item.agentUid) return ''
      else return ''
    },
    getOrgId (tenantKey = '') {
      return this.$store.getters.organizationKeyToId.get(tenantKey) || ''
    },
    /** @param {FsFile} file */
    downloadFile (file) {
      return this.$store.dispatch('downloadFile', file)
    },
    showResolvePopup () {
      this.resolveDialogFlag = true
    },
    onSupportResolved () {
      if (this.supportInEdit) {
        this.supportInEdit.status = 'closed'
      }
      this.supportInEditNewStatus = 'closed'
    },
    showEditTagsPopup (item) {
      this.currentItemTagKeys = item.supportTags || []
      this.isShowEditTagsPopup = true
      this.supportInEdit = item
    },
    saveTags () {
      return this.dispatchAndToast(this.$store.dispatch('updateSupport', {key: this.supportInEdit._key, supportTags: this.currentItemTagKeys}))
        .then(() => {
          this.isShowEditTagsPopup = false
        })
    }
  }
}
</script>

<style>
.chatroom-op {
  padding-top: 0;
}

.badge {
  font-size: 10px;
}

.question-medium {
  overflow-wrap: break-word !important;
  max-width: 20vw
}
.question-large {
  overflow-wrap: break-word !important;
  max-width: 30vw
}
.question-xlarge {
  overflow-wrap: break-word !important;
  max-width: 40vw
}
.bagdeRightTopClass .v-badge__badge {
  top: -24px;
  right: -28px;
}
.btnWithoutPaddingMargin .v-btn {
  padding: 0;
  min-width: 50px;
}
.rtSearch {
  margin: 0;
  padding: 0;
  height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/Support.vue